import React, { createContext, useState, useContext } from 'react';

// Create the context
const RefreshContext = createContext();

// Custom Provider component
export const RefreshProvider = ({ children }) => {
  //console.log(children );
  const [refresh, setRefresh] = useState(false);

  const triggerRefresh = () => {
    setRefresh(prev => !prev);
  };

  return (
    <RefreshContext.Provider value={{ refresh, triggerRefresh }}>
      {children}
    </RefreshContext.Provider>
  );
};

// Custom hook to use the context
export const useRefreshContext = () => useContext(RefreshContext);